export const API_PATH_ApiAlertMgtmAlertHandlingResolve = '/services/alerts-mgtm/apiAlertMgtmAlertHandlingResolve';
